/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ChargeType = "dynamic" | "static" | "%future added value";
export type ChargePriceInput = {
    price: number;
    currency: string;
};
export type mutationsAddChargeMutationVariables = {
    serviceID: string;
    name: string;
    description: string;
    prices: Array<ChargePriceInput>;
    metricName?: string | null;
    chargeType: ChargeType;
};
export type mutationsAddChargeMutationResponse = {
    readonly addCharge: {
        readonly id: string;
    };
};
export type mutationsAddChargeMutation = {
    readonly response: mutationsAddChargeMutationResponse;
    readonly variables: mutationsAddChargeMutationVariables;
};



/*
mutation mutationsAddChargeMutation(
  $serviceID: ID!
  $name: String!
  $description: String!
  $prices: [ChargePriceInput!]!
  $metricName: String
  $chargeType: ChargeType!
) {
  addCharge(input: {serviceID: $serviceID, name: $name, description: $description, prices: $prices, metricName: $metricName, chargeType: $chargeType}) {
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chargeType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metricName"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "prices"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "serviceID"
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "chargeType",
            "variableName": "chargeType"
          },
          {
            "kind": "Variable",
            "name": "description",
            "variableName": "description"
          },
          {
            "kind": "Variable",
            "name": "metricName",
            "variableName": "metricName"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          },
          {
            "kind": "Variable",
            "name": "prices",
            "variableName": "prices"
          },
          {
            "kind": "Variable",
            "name": "serviceID",
            "variableName": "serviceID"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Charge",
    "kind": "LinkedField",
    "name": "addCharge",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "mutationsAddChargeMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "mutationsAddChargeMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "a6d5c05edf188a89e5fcdfa4b7c62e16",
    "id": null,
    "metadata": {},
    "name": "mutationsAddChargeMutation",
    "operationKind": "mutation",
    "text": "mutation mutationsAddChargeMutation(\n  $serviceID: ID!\n  $name: String!\n  $description: String!\n  $prices: [ChargePriceInput!]!\n  $metricName: String\n  $chargeType: ChargeType!\n) {\n  addCharge(input: {serviceID: $serviceID, name: $name, description: $description, prices: $prices, metricName: $metricName, chargeType: $chargeType}) {\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b104676776ade65163a4b422308b0bf2';
export default node;
